import { Markdown } from "PFComponents/markdown";
import { Typography } from "PFComponents/typography";
import { MatchedActivity } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { Section } from "../../components";

type DescriptionSectionProps = {
  role: MatchedActivity["activity"];
};

export const DescriptionSection = ({ role }: DescriptionSectionProps) => {
  const { t } = useTranslation("marketplace", { keyPrefix: "workOpportunities.roleDetails.description" });

  return (
    <Section title={t("title")}>
      <Typography variant="bodyRegular" noMargin>
        <Markdown raw={role.description} crop={750} emojify={false} />
      </Typography>
    </Section>
  );
};
